import React from 'react';

import { Flex, Stack } from '@atlaskit/primitives/compiled';

import { getFeatureInfo } from '../../../common/getFeatureInfo';
import type { AudioFeature } from '../../../types/audioFeature';
import { useAudioPlayerStore } from '../../hooks/useAudioPlayerStore';
import { ModifyPlaylistButton } from '../playlist/ModifyPlaylistButtons';

import type { FlagsContainer } from './AudioContainer';
import { AudioFeatureToggle } from './AudioFeatureToggle';
import { AudioHeader } from './AudioHeader';

export type AudioHeaderPanelProps = {
	featureList: AudioFeature[];
	cloudId: string;
	flags?: FlagsContainer;
};

export const AudioHeaderPanel = ({
	featureList,
	flags,
}: AudioHeaderPanelProps): React.JSX.Element => {
	const { activeFeature, setActiveFeature, cloudId } = useAudioPlayerStore();

	const activeFeatureInfo = getFeatureInfo(activeFeature, featureList);

	const getNextFeature = () => {
		const currentIndex = featureList.findIndex(
			(feature) => feature.name === activeFeatureInfo?.name,
		);
		const nextIndex = (currentIndex + 1) % featureList.length;
		return featureList[nextIndex];
	};
	const { activeContent } = useAudioPlayerStore();

	return (
		<Stack space="space.250" alignInline="center">
			<AudioHeader featureList={featureList} />
			<Flex gap="space.050" alignItems="center">
				<ModifyPlaylistButton
					round={true}
					cloudId={cloudId}
					contentId={activeContent.contentId}
					contentType={activeContent.contentType}
					flags={flags}
					title={activeContent.title}
				/>
				<AudioFeatureToggle
					featureList={featureList}
					onClick={() => setActiveFeature(getNextFeature().name)}
				/>
			</Flex>
		</Stack>
	);
};
